/*
  tourSteps — התוכן והסדר של סיור ההיכרות. כל שלב מגדיר:
    - route:    לאיזה מסך לנווט לפני שמדגישים (הסיור נכנס למסך האמיתי ומסמן שם).
    - selector: איזה אלמנט להדגיש. הוא מסומן ב-data-tour במסך עצמו.
    - title/body: כותרת והסבר קצר בחלונית.
    - placement:"top": החלונית מעל האלמנט (למשל התפריט התחתון).

  כדי שלא תהיה טעינה ארוכה בין השלבים, חבילות הקוד של כל המסכים נטענות מראש
  ברגע שהסיור מתחיל (tourPreload) — כך שהניווט מיידי.

  אם אלמנט לא נמצא (למשל הרשאת "צפייה בלבד" שמסתירה כפתורי עריכה) — החלונית
  מופיעה במרכז המסך עם ההסבר, כך שהסיור לעולם לא נתקע.
*/
export const TOUR_STEPS = [
  {
    key: "nav",
    route: "/",
    selector: '[data-tour="nav"]',
    placement: "top",
    title: "התפריט התחתון",
    body: "מכאן עוברים בין המסכים הראשיים: בית, תלמידים, לוח שנה, מתנות וקבצים. הוא תמיד זמין בתחתית המסך.",
  },
  {
    key: "balance",
    route: "/",
    selector: '[data-tour="balance"]',
    title: "עדכון יתרה",
    body: "כאן, במסך הבית, מעדכנים את יתרת הקופה — רושמים הוצאה שיצאה, והמאזן מתעדכן מיד.",
  },
  {
    key: "add-student",
    route: "/students",
    selector: '[data-tour="add-student"]',
    title: "הוספת תלמיד",
    body: "במסך התלמידים מוסיפים ילד אחד בכל פעם — או מייבאים רשימה שלמה מקובץ. לכל תלמיד נרשמים התשלומים שלו.",
  },
  {
    key: "add-event",
    route: "/calendar",
    selector: '[data-tour="add-event"]',
    title: "הוספת אירוע ותזכורת",
    body: "מוסיפים אירוע ללוח השנה, ואפשר לסמן שתישלח עליו תזכורת להורים בוואטסאפ — כך אף אחד לא שוכח.",
  },
  {
    key: "suppliers",
    route: "/gifts",
    selector: '[data-tour="suppliers"]',
    title: "בדיקת ספקים",
    body: "רשימת הספקים המומלצים למתנות ולאירועים. אפשר לעיין, להשוות מחירים ולפנות אליהם ישירות — הכול במקום אחד.",
  },
  {
    key: "edit-collection",
    route: "/collection-settings",
    selector: '[data-tour="edit-collection"]',
    title: "עריכת גבייה",
    body: "כאן קובעים כמה גובים ועל מה — הקטגוריות והסכומים. השינוי משפיע על מסך הבית ועל התשלום של כל תלמיד.",
  },
  {
    key: "settings-payments",
    route: "/settings?section=payments",
    selector: '[data-tour="settings-payments"]',
    title: "הגדרות תשלומים",
    body: "מזינים כאן את קישורי הביט/פייבוקס ופרטי חשבון הבנק — כדי שההורים ידעו לאן לשלם בלחיצה אחת.",
  },
  {
    key: "pro",
    route: "/upgrade",
    selector: '[data-tour="pro"]',
    title: "שדרוגי פרו",
    body: "המסלול המורחב פותח כלים מתקדמים: בקשות תשלום בוואטסאפ, ריבוי גנים, חברי ועד והרשאות ועוד. זהו — סיימנו את הסיור! 🎉",
  },
];
